import EmptyHolder from 'components/EmptyHolder'
import React from 'react'

const WorkspaceOperatingStatistic = ({ ...props }) => <EmptyHolder />

export default WorkspaceOperatingStatistic
